import React from 'react';
import { has, isEmpty } from 'lodash';
import styled from 'styled-components';

import AutoComplete from 'components/ui/AutoComplete';
import { FormSectionTitle } from 'styles/form';

const Content = styled.div`
  display: grid;
  grid-gap: 1em;
  grid-template-columns: 1fr 1fr;
`;

const SubRelationSection = ({
  sectionTitle,
  data,
  children,
  name,
  setFieldValue,
  value,
  getOptionLabel,
  groupBy,
  selection,
  fullName,
  handleAdd,
  errors,
  touched,
  required,
}) => (
  <>
    <FormSectionTitle>{sectionTitle}</FormSectionTitle>

    <Content>
      <AutoComplete
        data={data}
        label={sectionTitle}
        name={name}
        setFieldValue={setFieldValue}
        value={value}
        getOptionLabel={getOptionLabel}
        groupBy={groupBy}
        selection={selection}
        fullName={fullName}
        handleAdd={handleAdd}
        error={touched[`${name}`] && has(errors, name)}
        touched={touched}
        bottom="-2"
        required={required}
      />

      {!isEmpty(selection) && children}
    </Content>
  </>
);

export default SubRelationSection;
